import {Banner, Dialog} from '@primer/react'
import {useIsLoading} from '../contexts/IsLoadingContext'
import {PreviewsTable} from './previews-table'
import {EnforcementPicker} from './enforcement-picker'
import {PreviewsCountSummary} from './previews-count-summary'
import type {EditablePreview} from '../types'
import {useButton} from '../contexts/ButtonContext'

type SelectionDialogProps = {
  previews: EditablePreview[]
  errorMessage: string | null
  isValid?: boolean
  onCancel(): void
  onSelection(): void
}

export function SelectionDialog({previews, errorMessage, isValid, onCancel, onSelection}: SelectionDialogProps) {
  const isLoading = useIsLoading()
  const {buttonRef} = useButton()

  return (
    <Dialog
      title="Review import"
      width="large"
      height="large"
      returnFocusRef={buttonRef}
      onClose={onCancel}
      footerButtons={[
        {
          buttonType: 'default',
          content: 'Cancel',
          onClick: onCancel,
        },
        {
          buttonType: 'primary',
          content: 'Create rulesets',
          disabled: !isValid,
          loading: isLoading,
          onClick: onSelection,
          ref: buttonRef,
        },
      ]}
    >
      <Dialog.Body>
        <div className="d-flex flex-column gap-3">
          {errorMessage && (
            <Banner title="Error" hideTitle variant="critical">
              <Banner.Description>{errorMessage}</Banner.Description>
            </Banner>
          )}
          <PreviewsCountSummary previews={previews} />
          <EnforcementPicker />
          <PreviewsTable previews={previews} />
        </div>
      </Dialog.Body>
    </Dialog>
  )
}
